/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class SetFieldData implements IDirective {
        public controller = ["$scope", "treeItemService", "treeService", SetFieldDataController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/setFieldData.html';
        public restrict: string = "E";

        public scope: any = {
            setDataOperation: "=",
            processConfigId: "=",
            allowListOnly: "="
        };

        public link(scope: ISetFieldDataScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: SetFieldDataController): void {
        }
    }

    export interface ISetFieldDataScope extends ng.IScope {
        setDataOperation: Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto;
        processConfigId: string;

        sourceTreeItem: Wars.Domain.Model.TreeItem;
        destinationTreeItem: Wars.Domain.Model.TreeItem;
        allowListOnly: boolean;

        onSourceDragOver($event: any): void;
        onSourceDrop($event: any): void;

        onDestinationDragOver($event: any): void;
        onDestinationDrop($event: any): void;
    }

    export class SetFieldDataController implements IController {

        private isSystemLevel: boolean;

        constructor(
            private $scope: ISetFieldDataScope,
            private treeItemService: services.TreeItemService,
            private treeService: services.TreeService)
        {
            this.$scope.onSourceDragOver = ($event: any) => this.onSourceDragOver($event);
            this.$scope.onSourceDrop = ($event: any) => this.onSourceDrop($event);
            this.$scope.onDestinationDragOver = ($event: any) => this.onDestinationDragOver($event);
            this.$scope.onDestinationDrop = ($event: any) => this.onDestinationDrop($event);

            this.$scope.$watch('setDataOperation',
                () => {
                    this.setDataOperationChanged();
                });
        }

        private setDataOperationChanged(): void {
            if (this.$scope.setDataOperation) {
                if (this.$scope.setDataOperation.sourceTreeItem_id) {
                    this.treeItemService.getTreeItem(this.$scope.setDataOperation.sourceTreeItem_id)
                        .then((treeItem) => {
                            this.$scope.sourceTreeItem = treeItem;
                            (<any>this.$scope.sourceTreeItem).detailedDisplay = this.getTreeItemDisplay(treeItem);
                            this.treeService.getDetailedDisplayName(treeItem).then((detailedName) => {
                                if (detailedName) {
                                    (<any>this.$scope.sourceTreeItem).detailedDisplay = detailedName;
                                }
                            });
                        });
                }
                if (this.$scope.setDataOperation.destinationTreeItem_id) {
                    this.treeItemService.getTreeItem(this.$scope.setDataOperation.destinationTreeItem_id)
                        .then((treeItem) => {
                            this.$scope.destinationTreeItem = treeItem;
                            (<any>this.$scope.destinationTreeItem).detailedDisplay = this.getTreeItemDisplay(treeItem);
                            this.treeService.getDetailedDisplayName(treeItem).then((detailedName) => {
                                if (detailedName) {
                                    (<any>this.$scope.destinationTreeItem).detailedDisplay = detailedName;
                                }
                            });
                        });
                }
            } else {
                this.$scope.sourceTreeItem = undefined;
                this.$scope.destinationTreeItem = undefined;
            }
        }

        private getTreeItemDisplay(treeItem: Wars.Domain.Model.TreeItem): string {
            if (treeItem) {
                return this.treeService.getDisplayName(treeItem) + " of " + this.treeService.getParentDisplayName(treeItem);
            }
            return "";
        }

        private onSourceDragOver($event: any): void {
            
        }

        private onSourceDrop($event: any): void {
            // Purposely allowing list items on source, they will add a single row in the destination list

            var treeItem = this.treeService.createTreeItemFromItemDropped();

            this.$scope.sourceTreeItem = treeItem;
            this.$scope.setDataOperation.sourceTreeItem_id = treeItem.id;
            (<any>this.$scope.sourceTreeItem).detailedDisplay = this.getTreeItemDisplay(treeItem);

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
        }

        private onDestinationDragOver($event: any): void {

        }

        private onDestinationDrop($event: any): void {
            var treeConfig = this.treeService.getTreeConfigurationItem();

            if (treeConfig.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField &&
                treeConfig.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable) {
                alert("Data can only be copied into Form Fields and Process Variables.");
            }
            else if (this.$scope.allowListOnly && !treeConfig.isList) {
                alert("Only list properties can be selected.");
            }
            else if (treeConfig.isSystemLevel) {
                alert("Data can only be copied into Process Level Form Fields or Process Level Variables.  System Level tree items cannot be selected.");
            } else {
                var treeItem = this.treeService.createTreeItemFromItemDropped();

                this.$scope.destinationTreeItem = treeItem;
                this.$scope.setDataOperation.destinationTreeItem_id = treeItem.id;
                (<any>this.$scope.destinationTreeItem).detailedDisplay = this.getTreeItemDisplay(treeItem);
            }

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
        }
    }
}

warsApp.registerDirective('SetFieldData', []);